import { referrerDetailSearchSchema } from './referrerDetailSearchSchema';
import z from '@/lib/zod';
import { booleanParam } from '@/lib/helpers/list-api-params';
import { toLegacySubTab } from '@/lib/helpers/list-tabs';
import { REFERRER_TYPE_OPTIONS } from '@/pages/referrers/lib/referrer-badges';
import {
  REFERRERS_TABS,
  REFERRERS_VIEWS,
} from '@/pages/referrers/lib/referrers-filters';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

export const referrersSearchSchema = commonSearchSchema
  .extend({
    /** Tab della tabella (come la webapp). */
    subTab: optionalSearchString(),
    /**
     * Link di prima con lo stato attivo, scritto come stringa (`"true"`) dal
     * filtro del popover: diventa `subTab` e non esce dallo schema. Da
     * rimuovere dopo il 2026-12-31.
     */
    isActive: optionalSearchString(),
    type: z.enum(REFERRER_TYPE_OPTIONS).nullish().catch(undefined),
    parentId: optionalSearchString(),
    /** Vista della pagina: la rete raggruppata (default) o l'elenco. */
    view: z.enum(REFERRERS_VIEWS).optional().catch(undefined),
    /** Tipo proposto dal form `new` («Nuovo commerciale»). */
    newType: z.enum(REFERRER_TYPE_OPTIONS).optional().catch(undefined),
    ...referrerDetailSearchSchema.shape,
  })
  .transform(({ isActive, ...search }) => ({
    ...search,
    subTab: toLegacySubTab({
      tabs: REFERRERS_TABS,
      subTab: search.subTab,
      legacyFilter: booleanParam(isActive),
    }),
  }));

export type ReferrersSearch = z.output<typeof referrersSearchSchema>;
